import { Icon, Tag } from '@kolking/react-ui';

import { Layout } from '../../components/Layout';
import styles from './styles.module.scss';

const SuccessPage = () => {
  return (
    <Layout>
      <section className={styles.container}>
        <Tag
          as="h1"
          title="Submitted"
          variant="plain"
          scheme="green"
          className={styles.title}
          icon={<Icon name="checkmark-circle" />}
        />
        <p>
          Thank you for reporting your biosecurity concern to the Department of Agriculture,
          Fisheries, and Forestry. We aim to respond within 10 business days.
        </p>
      </section>
    </Layout>
  );
};

export default SuccessPage;
